import React, { useCallback, useEffect, useRef, useState } from "react";
import classes from "../style.module.scss";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { isEmpty } from "lodash";
import { fetchCommFilterOptions } from "utils/communities";
import { getRenoCommModelSortComparator } from "utils/directory/sorting";
import DashboardTable from "components/Dashboard/Table";
import Loading from "components/Loading";
import Card from "components/Card";
import RenoCommFilters from "./Filters";

const RenoModels = ({
    history,
    commModelDir = {},
}) => {
    const modelRef = useRef(null);
    const scrollContainerRef = useRef(null);

    /* Loading state and cursor position for loading spinner */
    const [cursorPosition, setCursorPosition] = useState({ top: 0, left: 0 });
    const [isLoading, setIsLoading] = useState(false);

    const [allModels, setAllModels] = useState([]);
    const [filteredModels, setFilteredModels] = useState([]);
    const [sortBy, setSortBy] = useState("name");
    const [sortOrder, setSortOrder] = useState("asc");

    // Options for filters
    const [locationOpts, setLocationOpts] = useState([]);
    const [userOpts, setUserOpts] = useState([]);
    const [modelOpts, setModelOpts] = useState([]);

    // Get cursor position for loading spinner
    const onMouseMove = useCallback((e) => {
        const top = e.pageY - window.scrollY + 10;
        const left = e.pageX - window.scrollX + 10;

        setCursorPosition({ top, left });
    }, []);

    // Update loading spinner location when cursor moves
    useEffect(() => {
        const handleMouseMove = (e) => {
            onMouseMove(e);
        };

        if (!isLoading) return;

        window.addEventListener("mousemove", handleMouseMove);
        window.addEventListener("wheel", handleMouseMove);

        return () => {
            window.removeEventListener("mousemove", handleMouseMove);
            window.removeEventListener("wheel", handleMouseMove);
        };
    }, [isLoading, onMouseMove]);

    // Get sorted list of commModels
    useEffect(() => {
        const { models: singleModels = {} } = commModelDir;
        const unfiltered = !isEmpty(singleModels)
            ? Object.entries(singleModels)
                .map(([key, el]) => [key, { ...el, type: "commModel" }])
                .sort(getRenoCommModelSortComparator(sortBy, sortOrder))
            : [];

        setAllModels(unfiltered);
        setFilteredModels(unfiltered);

        // Set filter dropdown options
        const { locationOpts, userOpts, modelOpts } = fetchCommFilterOptions(unfiltered.map(([key, model]) => ({ key, ...model })));
        setLocationOpts(locationOpts);
        setUserOpts(userOpts);
        setModelOpts(modelOpts);
    }, []);

    // Resort models and keep filters applied
    useEffect(() => {
        if (isEmpty(filteredModels)) return;

        const sorted = [...filteredModels].sort(getRenoCommModelSortComparator(sortBy, sortOrder));

        setFilteredModels(sorted);
    }, [sortBy, sortOrder]);

    return (
        <div
            className={classes.contentContainer}
            onMouseMove={onMouseMove}
            style={{ pointerEvents: isLoading ? "none" : "auto" }}
            ref={scrollContainerRef}
        >
            <div style={{ position: "fixed", pointerEvents: "none", ...cursorPosition }}>
                {isLoading && <Loading className={classes.smallerSpinner} subClassName={classes.smallSpinner} />}
            </div>
            
            <RenoCommFilters
                allModels={allModels}
                setFilteredModels={setFilteredModels}
                locationOpts={locationOpts}
                userOpts={userOpts}
                modelOpts={modelOpts}
            />
            
            <h2 className={classes.title}>
                House Models
            </h2>
            <DashboardTable
                // folderItemRef={modelRef}
                history={history}
                dirType={"renoCommModelDir"}
                allFoldersItems={filteredModels}
                itemType={"commModel"}
                setIsLoading={setIsLoading}
                paginate
                sortData={{ sortBy, setSortBy, sortOrder, setSortOrder }}
            />
            {isEmpty(filteredModels) && <Card>No community models match the filters you applied</Card>}
        </div>
    );
};

const mapStateToProps = createStructuredSelector({});

const mapDispatchToProps = (dispatch, { history }) => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(RenoModels);